import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

export const reportRemoveFromFavorites = () => {
    mixpanel.track('Logo Maker - Listing - Remove from Favorites', {
        ...getDataFromStores(
            store.user,
            store.brief,
            store.briefSource,
            store.pagePath,
            store.statistics,
            store.referrer,
            store.fromBoost
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.BUYER,
    });
};
